import type { ScoreSnapshot } from '../contract';
import { GaugeIcon, EyeIcon, MapPinIcon, StarIcon } from 'lucide-react';
import { StatTile } from '../primitives/StatTile';

/**
 * The KPI row, reworked from the prototype: visibility score, times named by
 * AI, best Google position, reviews. No social. No naked fractions — counts are
 * absolute and labelled (§Your score).
 */
export function KpiRow({ snapshot, reviewCount, reviewRating }: {
  snapshot: ScoreSnapshot;
  reviewCount: number | null;
  reviewRating: number | null;
}) {
  const { total, plusMinus, headline } = snapshot;
  return (
    <div className="mb-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
      <StatTile
        icon={GaugeIcon}
        label="Visibility score"
        value={total ?? '—'}
        badge={total !== null ? `± ${plusMinus}` : undefined}
        tooltip="How often AI and Google put you in front of a potential customer, out of 100. The ± is how sure we are."
      />
      <StatTile
        icon={EyeIcon}
        label="Times AI named you"
        value={headline.mentionsTotal}
        badge={`of ${headline.questionsTested} questions`}
        tooltip="How many times an AI assistant named your business across every question and engine we asked on your behalf."
      />
      <StatTile
        icon={MapPinIcon}
        label="Best Google spot"
        value={headline.bestGooglePosition !== null ? `#${headline.bestGooglePosition}` : '—'}
        tooltip="Your highest position in Google search results across the questions we track."
      />
      <StatTile
        icon={StarIcon}
        label="Reviews"
        value={reviewCount ?? '—'}
        badge={reviewRating !== null ? `${reviewRating}★` : undefined}
        tooltip="How many reviews customers have left you, and your average rating. AI reads these as a sign you are trusted."
      />
    </div>
  );
}
